module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "combinationInventorycontainer",
    staticClass: "combinationInventory-container common-container"
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "30px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "height": "35px",
      "line-height": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.preStep
    }
  }, [_vm._v("返回到组合清单")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "hzpbtn-info",
    staticStyle: {
      "float": "right",
      "height": "35px",
      "line-height": "10px",
      "margin-right": "2px"
    },
    attrs: {
      "type": "info",
      "plain": ""
    },
    on: {
      "click": _vm.pagePositionClick
    }
  }, [_vm._v(_vm._s(_vm.pagePosition))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "100px",
      "font-size": "20px",
      "margin-top": "4px",
      "margin-right": "-5px"
    }
  }, [_c('label', [_vm._v("上级位置：")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "addFormData",
    staticClass: "form-data-nopadding",
    attrs: {
      "model": _vm.addFormData,
      "rules": _vm.addRules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择商品",
      "prop": "spcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList
    },
    model: {
      value: (_vm.addFormData.spcode),
      callback: function($$v) {
        _vm.$set(_vm.addFormData, "spcode", $$v)
      },
      expression: "addFormData.spcode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('sp')
      }
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "100%",
      "height": "40px",
      "line-height": "40px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary",
      "disabled": !_vm.cid
    },
    on: {
      "click": function($event) {
        return _vm.handleAddSubmit('addFormData')
      }
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    staticStyle: {
      "margin-left": "50px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品快速搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vagueContent),
      callback: function($$v) {
        _vm.vagueContent = $$v
      },
      expression: "vagueContent"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 55 - 95,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "type": "index",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spcode",
      "label": "商品编码",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spname",
      "label": "商品名称",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spmoney",
      "label": "商品价格",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.enableData(scope.$index, scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === '0' ? '禁用' : '启用'))]), _vm._v("|\n\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "500px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择商品",
      "prop": "spcode"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchSpList,
      "id": "focus-ele"
    },
    model: {
      value: (_vm.formData.spcode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "spcode", $$v)
      },
      expression: "formData.spcode"
    }
  }, _vm._l((_vm.spDatas), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "width": "20px"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "清除选择的商品",
      "placement": "top",
      "effect": "light"
    }
  }, [_c('el-button', {
    attrs: {
      "icon": "el-icon-close"
    },
    on: {
      "click": function($event) {
        return _vm.clearInventory('editsp')
      }
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9009fb8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/inventoryManagement/CombinationInventory.vue
// module id = 716
// module chunks = 1